// Disable noisy developer console in production on the real domain
// Keeps warnings and errors visible; silences other debug noise
// Also blocks DevTools access in production
(() => {
  // Vite env flags
  const env = (import.meta as any).env || {};
  const isProd = env.PROD === true || env.MODE === 'production';
  if (!isProd) return;

  // Only apply on the production hostname
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const isProdHost = host === 'mernaki.de' || host.endsWith('.mernaki.de');
  if (!isProdHost) return;

  // List of console methods to silence in production
  const methods: Array<keyof Console> = [
    'log',
    'debug',
    'info',
    'trace',
    'group',
    'groupCollapsed',
    'groupEnd',
    'time',
    'timeEnd',
    'timeLog',
    'table',
    'dir',
    'dirxml',
    'count',
    'countReset',
    'profile',
    'profileEnd'
  ];

  try {
    methods.forEach((m) => {
      try {
        (console as any)[m] = () => {};
      } catch {}
    });
  } catch {}

  // Best-effort: disable React DevTools hook in production
  try {
    const hook = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (hook && typeof hook === 'object') {
      Object.keys(hook).forEach((k) => {
        try {
          const v = hook[k];
          (hook as any)[k] = typeof v === 'function' ? () => {} : null;
        } catch {}
      });
    }
  } catch {}

  // Block DevTools shortcuts and context menu in production
  try {
    // Block context menu (Right Click)
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    // Block DevTools shortcuts
    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
      }
      // Ctrl+Shift+I / Cmd+Opt+I (Inspector)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
        e.preventDefault();
      }
      // Ctrl+Shift+J / Cmd+Opt+J (Console)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'J' || e.key === 'j')) {
        e.preventDefault();
      }
      // Ctrl+Shift+C / Cmd+Opt+C (Inspect Element)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'C' || e.key === 'c')) {
        e.preventDefault();
      }
      // Ctrl+U / Cmd+U (View Source)
      if ((e.ctrlKey || e.metaKey) && (e.key === 'U' || e.key === 'u')) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    // Additional DevTools detection and blocking
    let devtools = { open: false, orientation: null };
    const threshold = 160;

    setInterval(() => {
      if (window.outerHeight - window.innerHeight > threshold || 
          window.outerWidth - window.innerWidth > threshold) {
        if (!devtools.open) {
          devtools.open = true;
          // Redirect or show warning when DevTools detected
          try {
            document.body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:Arial,sans-serif;background:#f5f5f5;color:#333;text-align:center;"><div><h1>Access Restricted</h1><p>Developer tools are disabled for security reasons.</p></div></div>';
          } catch {}
        }
      } else {
        devtools.open = false;
      }
    }, 500);

    // Prevent console access attempts
    try {
      Object.defineProperty(window, 'console', {
        get: function() {
          return {
            log: () => {},
            warn: () => {},
            error: () => {},
            info: () => {},
            debug: () => {},
            trace: () => {},
            dir: () => {},
            group: () => {},
            groupCollapsed: () => {},
            groupEnd: () => {},
            time: () => {},
            timeEnd: () => {},
            timeLog: () => {},
            table: () => {},
            clear: () => {},
            count: () => {},
            countReset: () => {},
            assert: () => {},
            profile: () => {},
            profileEnd: () => {},
            dirxml: () => {}
          };
        },
        set: function() {
          // Prevent console reassignment
        }
      });
    } catch {}
  } catch {}
})();

export {};